<template>
    <div v-if="params.inputType == 'input' " class="inputWidth">
        <!-- <el-input v-model="params.value" :type="params.typeValue" :placeholder="params.placeholder"
         :disabled="params.disabled" :rows="params.rows || 5"  clearable></el-input> -->
        <el-input v-model="params.value" :type="params.typeValue" :placeholder="'请输入'+$utils.labelByValue_global(params)"
         :disabled="params.disabled" :rows="params.rows || 5"  clearable></el-input>
    </div>
    <div v-else-if="params.inputType == 'inputText'">
        {{ params.value }}
    </div>
    <div v-else-if="params.inputType == 'input_section'" class="input_section_class" >
        <div style="display:flex" v-for="(item,index) in params.inputSection">
            <el-input v-model="item.value" :type="item.typeValue" :placeholder="item.placeholder"
            :disabled="item.disabled" clearable></el-input>
            <span v-if="index+1 < params.inputSection.length" style="margin:0px 5px">-</span>
        </div>
        <!-- <el-input v-model="params.inputSection[0].value" :type="params.typeValue" :placeholder="params.placeholder"
         :disabled="params.disabled" clearable></el-input>
         -
         <el-input v-model="params.inputSection[1].value" :type="params.typeValue" :placeholder="params.placeholder"
         :disabled="params.disabled" clearable></el-input> -->

    </div>
    <!-- 下拉 -->
    <div v-else-if="params.inputType == 'select'">
        <!-- :filterable=Boolean(params.filterable) -->
        <el-select v-model="params.value" :placeholder="params.placeholder"  filterable
        :multiple="params.multiple"  :disabled="params.disabled" :collapse-tags="params.multiple"
        @change="(val)=>{params.change ? params.change(val) : ''}" clearable>
            <el-option
                v-for="item in params.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
            </el-option>
        </el-select>
    </div>
    <!-- 下拉  入参跟传参都是相同值 -->
    <div v-else-if="params.inputType == 'selectIdentical'">
        <!-- :filterable=Boolean(params.filterable) -->
        <el-select v-model="params.value" :placeholder="params.placeholder"  filterable
        @change="(val)=>{params.change ? params.change(val) : ''}" clearable>
            <el-option
                v-for="item in params.options"
                :key="item.id"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
            </el-option>
        </el-select>
    </div>
    <!-- 时间选择 -->
    <div v-else-if="params.inputType == 'date'">
            <el-date-picker
                v-model="params.value"
                :type="params.typeValue"
                :disabled="params.disabled"
                :picker-options="params.pickerOptions"
                :format="params.format"
                :value-format = "params.format"
                :default-value="params.defaultValue"
                :placeholder="params.placeholder"
                :start-placeholder="params.startPlaceholder"
                :end-placeholder="params.endPlaceholder"
                @change="(val)=>{params.change ? params.change(val) : ''}"
                unlink-panels
                clearable
                >
            </el-date-picker>
    </div>
    <!-- 图片可预览 -->
    <div v-else-if="params.inputType == 'img'">
        <el-image 
            style="width: 100px; height: 100px"
            :src="paramns.value" 
            :preview-src-list="[params.value]">
        </el-image>
    </div>
</template>

<script>
    export default {
        props: {
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
        },
        watch:{
        },
        data() {
            return {
                pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value1: '',
        value2: ''
            }
        },
        destroyed () {
            this.$off();
        },
        mounted () {
        },
    }
</script>

<style lang="scss" scoped>
    .input_section_class{
        display:flex;
        align-items:center;
    }
    /deep/ .el-input{
        width: 100% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/input/index.vue